import React, { memo } from "react";
import classes from "./SectionHeader.scss";
import { useTranslation } from "react-i18next";
import { Tag } from "@toddle-edu/ds-web";
import classnames from "classnames";
import { formatDate } from "Utils";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";
import { TRANSCRIPT_DATA_SOURCE } from "../../module/constants";

const SectionHeader = ({
  lastSyncAt,
  isLoading,
  dataSource,
  title,
  subText,
  lastSyncedText,
  style,
  rightComponent,
}) => {
  const { t } = useTranslation(["transcript"]);

  const isToddleDefined = dataSource === TRANSCRIPT_DATA_SOURCE.TODDLE;
  const titleClassName = classnames("text-label", classes.textLabel);

  const formattedLastSyncAt = lastSyncAt
    ? formatDate({
        date: lastSyncAt,
        format: DATE_TIME_CONSTANTS.DD_MMM__YYYY_hh_mm_A,
      })
    : "-";

  return (
    <div
      className={classnames(classes.header, {
        [classes.headerWithSubText]: Boolean(subText),
      })}
      style={style}
    >
      <div className={classes.titleSection}>
        <div className={classes.titleContainer}>
          <p className={titleClassName}>{title}</p>
          {dataSource ? (
            <Tag
              color={isToddleDefined ? "teal" : "yellow"}
              size="small"
              type="filled"
            >
              {isToddleDefined
                ? t("transcript:from_toddle")
                : t("common:custom")}
            </Tag>
          ) : null}
        </div>
        {subText ? (
          <p className={classnames("text-body-s", classes.subText)}>
            {subText}
          </p>
        ) : null}
      </div>
      <div className={classes.rightContainer}>
        {isLoading ? null : (
          <div className={classnames("text-body-s", classes.lastSynced)}>
            <span>{lastSyncedText || t("transcript:last_synced_on")} </span>
            <span>{formattedLastSyncAt}</span>
          </div>
        )}
        {rightComponent ? (
          <div className={classes.rightComponent}>{rightComponent}</div>
        ) : null}
      </div>
    </div>
  );
};

export default memo(SectionHeader);
